import MidCycleFluxChangeBadge from "../../container/MidCycleFluxChangeBadge";
import { capitalizeFirstLetter } from "../../../components/utils/Date";

/**
 * Composant pour afficher les tags d'une ligne de collection
 */
const INFO_TAG_CLASS_NAME =
  "rounded-full py-1 px-3 border border-gray-500 cursor-default";

const CHARACTERIZATION_STATUS_LABEL_KEYS = {
  ImageEnTraitement: "Image en traitement",
  ACompleter: "A compléter",
  Validated: "Validated",
};

const CollectionRowTags = ({
  timeLine,
  tags,
  toCharacterization,
  clientName,
  t,
  onMidCycleFluxValidated,
}) => {
  const characterizationStatusLabel = CHARACTERIZATION_STATUS_LABEL_KEYS[
    timeLine?.characterizationStatus
  ]
    ? t(CHARACTERIZATION_STATUS_LABEL_KEYS[timeLine.characterizationStatus])
    : null;
  return (
    <div className="w-full flex pt-3 pb-2">
      <div className="w-full flex flex-wrap items-center gap-2 text-sm text-gray-500">
        <span className={INFO_TAG_CLASS_NAME}>{timeLine.addressName}</span>
        {timeLine?.positioning && (
          <span className={INFO_TAG_CLASS_NAME}>
            {capitalizeFirstLetter(timeLine.positioning)}
          </span>
        )}
        {timeLine?.midCycleFluxChange?.active ? (
          <MidCycleFluxChangeBadge
            container={timeLine}
            variant="table"
            onValidated={onMidCycleFluxValidated}
          />
        ) : null}
        {tags && tags.length > 0
          ? tags.map(
              (item) =>
                item !== "tag1" && (
                  <span key={item.id} className={INFO_TAG_CLASS_NAME}>
                    {t(item.label)}
                  </span>
                ),
            )
          : ""}
        {clientName && (
          <span className={`${INFO_TAG_CLASS_NAME} capitalize`}>
            {clientName.toLowerCase()}
          </span>
        )}
        {toCharacterization && (
          <span className="inline-flex h-[30px] items-center rounded-full border-0 bg-[#F3F4F6] px-3 py-1 text-sm font-medium capitalize text-[#6B7280] cursor-default">
            {t("Level 2 characterization")}
            {characterizationStatusLabel
              ? ` · ${characterizationStatusLabel}`
              : ""}
          </span>
        )}
      </div>
    </div>
  );
};

export default CollectionRowTags;
